import { render, staticRenderFns } from "./cogsBarChart.vue?vue&type=template&id=080b09b2&scoped=true"
import script from "./cogsBarChart.vue?vue&type=script&lang=js"
export * from "./cogsBarChart.vue?vue&type=script&lang=js"
import style0 from "./cogsBarChart.vue?vue&type=style&index=0&id=080b09b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080b09b2",
  null
  
)

export default component.exports